'use client';

import { WCHANCE_LABEL_STATUS } from '@/constants';
import { Format } from '@/lib/dateFns';
import { WChanceCard as CommonWChanceCard, formatDateCommon } from '@monorepo/common';
import type { WChanceEventItem } from '../../types';

function WChanceCard({
  wChanceEvents,
  hasDetail = false,
  hasMultiLabel = false,
  wChanceDescription,
}: {
  wChanceEvents: Array<WChanceEventItem>;
  hasDetail?: boolean;
  hasMultiLabel?: boolean;
  wChanceDescription?: React.ReactNode;
}) {
  return (
    <CommonWChanceCard
      wChanceEvents={wChanceEvents}
      hasDetail={hasDetail}
      hasMultiLabel={hasMultiLabel}
      wChanceDescription={wChanceDescription}
      formatDateCommon={formatDateCommon}
      Format={Format}
      WCHANCE_LABEL_STATUS={WCHANCE_LABEL_STATUS}
      labelStatusConfig={{
        is_session: { text: '開催中', color: 'primary' },
        soon_start: { text: 'まもなく開始', color: 'cyan' },
        finish: { text: '終了', color: 'gray' },
        sold_out: { text: '売り切れ', color: 'gray' },
      }}
    />
  );
}

export default WChanceCard;
